import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-thank-you-common',
  templateUrl: './thank-you-common.html',
  styleUrls: ['./thank-you-common.scss'],
  imports: [RouterLink]
})
export class ThankYouCommonComponent {}
